import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../Button';

interface BackButtonProps {
  path?: string;
  text: string;
  goBack?: boolean;
}

export function FooterButton({ path, text, goBack }: BackButtonProps) {
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    if (goBack) {
      navigate(-1);
    } else if (path) {
      navigate(path);
    }

    window.scrollTo(0, 0);
  }, [navigate, goBack, path]);

  return (
    <Button
      type="primary"
      className="w-[188px] text-sm h-6"
      onClick={handleGoBack}
    >
      {text}
    </Button>
  );
}
